import {Unsubscriber as _Unsubscriber} from "@buildwithflux/shared";

import {CopilotChatStoreSetter} from "components/pages/document/components/editor/components/right_drawer/copilot_chat/state/useCopilotChatStore";

/**
 * Sets the knowledge base suggestions subscription
 */
export function setKnowledgeBaseSuggestionsSubscription(set: CopilotChatStoreSetter) {
    return (subscription: _Unsubscriber | null) => {
        set(
            (draft) => {
                draft.knowledgeBaseSuggestionsSubscription = subscription;
            },
            undefined,
            "setKnowledgeBaseSuggestionsSubscription",
        );
    };
}
